import React from 'react';
import { Route, Switch } from 'react-router-dom';

import HistoryForm from '../../../History/History/index';



export default () => (
  <Switch>
    <Route path="/history/history" component={HistoryForm} />
    
    
  </Switch>
);
